import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import * as validFunc from 'libs/validation';

const ReduxFormField = ({ component, ...rest }) => {
  const validCheck = [];
  if (Array.isArray(rest.validate)) {
    for (let i = 0; i < rest.validate.length; i++) {
      if (typeof validFunc[rest.validate[i]] === 'function') {
        validCheck.push(validFunc[rest.validate[i]]);
      } else {
        console.log('validation function wrong(validate):' + rest.validate[i]);
      }
    }
  }
  if (validCheck.length > 0) {
    rest.validate = validCheck;
  }

  const warnCheck = [];
  if (Array.isArray(rest.warn)) {
    for (let i = 0; i < rest.warn.length; i++) {
      if (typeof validFunc[rest.warn[i]] === 'function') {
        warnCheck.push(validFunc[rest.warn[i]]);
      } else {
        console.log('validation function wrong(wran):' + rest.warn[i]);
      }
    }
  }
  if (validCheck.length > 0) {
    rest.warn = warnCheck;
  }

  return <Field component={component} {...rest} />;
};

ReduxFormField.propTypes = {
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object]).isRequired,
  rest: PropTypes.object
};

export default ReduxFormField;



// WEBPACK FOOTER //
// ./src/script/components/reduxForm/ReduxFormField.js